import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { CircularProgress } from '@material-ui/core';
import { httpRequest } from '../../../../httpRequest';
import { makeStyles } from '@material-ui/core/styles';
import { arrayBufferFromBase64, saveFile } from '../../../ActivityCenter/SubComponents/caseFiles';
import { ADVISOR_OBJECT_KEY, getSessionStorageItem } from "../../../../sessionStorage";
import { v4 as uuid } from 'uuid';

const useStyles = makeStyles((theme) => ({
    primaryColor: {
        color: `${theme.palette.primary.main} !important`,
    },
}));

export default function Submit(props) {
    const classes = useStyles();

    const [show, setShow] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const fileList = props.fullFormState.pages.fileUpload.file && props.fullFormState.pages.fileUpload.file.fileList;
    const primaryInsuredInfo = props.fullFormState.pages.primaryInsuredInfo;
    const existingPolicyInformation = props.fullFormState.pages.existingPolicyInformation;

    const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
    const insuranceSpecialistURL = advisorObj && advisorObj.insuranceSpecialistURL;

    const generateInsuranceSpecialistUrl = () => {
      const uniqueID = uuid();
      return `${insuranceSpecialistURL}?ApplicationID=${uniqueID}`;
    }

    const getHealth = (healthClass) => {
        switch (healthClass) {
            case 'PP':
                return 'Exceptionally healthy (Preferred Plus)';
                break;
            case 'P':
                return 'Very healthy (Preferred)';
                break;
            case 'RP':
                return 'Above average health (Standard Plus)';
                break;
            case 'R':
                return 'Average health (Standard)';
                break;
            default:
                break;
        }
    }

    const downloadPDF = () => {
        const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
        setDownloadLoading(true)
        httpRequest.get(`${covrServicesUrl}/api/MorganStanley/GetPolicyReviewFile?policyReviewLeadID=${props.formState.policyReviewId}`)
            .then(response => {
                if (response.success) {
                    saveFile(response.content.fileDownloadName, arrayBufferFromBase64(response.content.fileContents))
                    setDownloadLoading(false)
                }
            }).catch((e) => {
                setDownloadLoading(false)
                console.log("error:" + e)
            });
    }

    return (
        <Container fluid className="border-class complate-page illustrationCompleteDiv">
            <Row className="px-5 pb-2 pt-4">
                <Col sm={7}>
                    <h4 className="mt-5 illustrationFont">
                        Your In-Force Ledger Request Has Been Generated
                    </h4>
                </Col>
                <Col sm={{span:3,offset:2}}>
                    <div className="text-center  mt-5">
                        <Button variant="contained" size="medium" color="primary" onClick={() => props.clearFormState()}>
                            SUBMIT ANOTHER REVIEW
                        </Button>
                    </div>
                    <div className="text-center mt-3">
                        <Button variant="contained" size="medium" color="primary" onClick={() => setShow(true)}>
                            VIEW POLICY REVIEW REPORT
                        </Button>
                    </div>
                </Col>
            </Row>


            {props.fullFormState.pages.inforceLedger.inForceLedgerType === 'inforceLedgerNeeded' &&
                <div>
                    <Row className="px-5">
                        <h3 className='ml-3'>
                            <b>You Are Almost Done:</b>
                        </h3>
                    </Row>
                    <div className="pt-2 px-5">
                        {downloadLoading ?
                            <Row className="d-flex ml-5">
                                <CircularProgress className="mt-5 mb-5" />
                            </Row> :
                            <Button variant="contained" size="medium" color="primary" onClick={() => downloadPDF()}>
                                DOWNLOAD THE IN-FORCE LEDGER REQUEST HERE
                            </Button>}
                    </div>
                </div>
            }
            <div className='px-5 py-5 '>
                <h6 className={`${classes.primaryColor} `}>Next Steps:</h6>
                {props.fullFormState.pages.inforceLedger.inForceLedgerType === 'inforceLedgerNeeded' &&
                    <ol>
                        <li>Print the policy review request form.</li>
                        <li>Client must sign form.</li>
                        <li>Provide signed form to your local <a href={generateInsuranceSpecialistUrl()}>insurance specialist</a> or return to this tool and select “I have an In-Force Ledger request signed by the policy owner” to submit the signed form. Once received, an insurance specialist will review your client's policy and be in touch shortly.</li>
                    </ol>
                }
                {props.fullFormState.pages.inforceLedger.inForceLedgerType === 'inforceLedgerRequest' &&
                    <ol>
                        <li>We will request the policy details from the carrier.</li>
                        <li>We will contact you with the result of the policy review as soon as possible.</li>
                    </ol>
                }
                {props.fullFormState.pages.inforceLedger.inForceLedgerType === 'hasInforceLedger' &&
                    <p>We will contact you with the results of the policy review as soon as it is ready.</p>
                }
            </div>
            <Modal size='xl' show={show} onHide={() => setShow(false)} animation={false} centered name='policy-review-modal' id='policy-review-modal'>

                <Modal.Body className="show-grid" name='policy-review-modal-content' id='policy-review-modal-content'>
                    <Container className='p-4' name='policy-review-report-container' id='policy-review-report-container'>
                        <Row>
                            <Col className="font-weight-bold pt-2"><h4 name='policy-review-report' id='policy-review-report'>Policy Review Report</h4></Col>
                            <Col className="text-right mt-0">
                                <IconButton aria-label="close" onClick={() => setShow(false)}>
                                    <CloseIcon name='policy-review-close-icon' id='policy-review-close-icon'/>
                                </IconButton>
                            </Col>
                        </Row>
                        {fileList &&
                            <React.Fragment>
                                <h5 className={`${classes.primaryColor}  font-weight-bold mt-3`} name='submitted-files-info' id='submitted-files-info'>Submitted Files</h5>
                                <Row>
                                    {fileList.map((item, index) =>
                                        <Col md={4}><b name={`submitted-files-text-${index+1}`} id={`submitted-files-text-${index+1}`}>File {index + 1}:</b> <span name={`submitted-files-value-${index+1}`} id={`submitted-files-value-${index+1}`}>{item.FileName}</span></Col>
                                    )}
                                </Row>
                            </React.Fragment>
                        }
                        <h5 className={`${classes.primaryColor}  font-weight-bold mt-3`} name='insured-info' id='insured-info'>Insured Information</h5>
                        <Row>
                            {primaryInsuredInfo.clientFirstName && <Col md={4}><b name='insured-first-name-text' id='insured-first-name-text'>First Name:</b> <span name='insured-first-name-value' id='insured-first-name-value'>{primaryInsuredInfo.clientFirstName}</span></Col>}
                            {primaryInsuredInfo.clientLastName && <Col md={4}><b name='insured-last-name-text' id='insured-last-name-text'>Last Name:</b> <span name='insured-last-name-value' id='insured-last-name-value'>{primaryInsuredInfo.clientLastName}</span></Col>}
                            {primaryInsuredInfo.birthdate && <Col md={4}><b name='insured-birthdate-text' id='insured-birthdate-text'>Date of Birth:</b> <span name='insured-birthdate-value' id='insured-birthdate-value'>{primaryInsuredInfo.birthdate}</span></Col>}
                            {primaryInsuredInfo.state && <Col md={4}><b name='insured-state-text' id='insured-state-text'>State:</b> <span name='insured-state-value' id='insured-state-value'>{primaryInsuredInfo.state}</span></Col>}
                            {primaryInsuredInfo.gender && <Col md={4}><b name='insured-gender-text' id='insured-gender-text'>Gender:</b> <span name='insured-gender-value' id='insured-gender-value'>{primaryInsuredInfo.gender === 'M' ? 'Male' : 'Female'}</span></Col>}
                            {primaryInsuredInfo.maritalStatus && <Col md={4}><b name='insured-marital-status-text' id='insured-marital-status-text'>Marital Status:</b> <span name='insured-marital-status-value' id='insured-marital-status-value'>{primaryInsuredInfo.maritalStatus}</span></Col>}
                            {primaryInsuredInfo.email && <Col md={4}><b name='insured-email-text' id='insured-email-text'>Email:</b> <span name='insured-email-value' id='insured-email-value'>{primaryInsuredInfo.email}</span></Col>}
                            {primaryInsuredInfo.health && <Col md={4}><b name='insured-health-text' id='insured-health-text'>Current Health Class:</b> <span name='insured-health-value' id='insured-health-value'>{getHealth(primaryInsuredInfo.health)}</span></Col>}
                            {existingPolicyInformation.tobacco && <Col md={4}><b name='insured-tobacco-text' id='insured-tobacco-text'>Use Tobacco:</b> <span name='insured-tobacco-value' id='insured-tobacco-value'>{existingPolicyInformation.tobacco}</span></Col>}
                        </Row>

                        {existingPolicyInformation.beneficiaries &&
                            <React.Fragment>
                                <h5 className={`${classes.primaryColor}  font-weight-bold mt-3`} name='existing-policy-beneficiary-info' id='existing-policy-beneficiary-info'>Existing Policy Information</h5>
                                <Row>
                                    <Col md={4}><b name='existing-policy-beneficiary-text' id='existing-policy-beneficiary-text'>Beneficiaries:</b> <span name='existing-policy-beneficiary-value' id='existing-policy-beneficiary-value'>{existingPolicyInformation.beneficiaries}</span></Col>
                                </Row>
                            </React.Fragment>
                        }

                        {existingPolicyInformation.carrier &&
                            <React.Fragment>
                            <h5 className={`${classes.primaryColor}  font-weight-bold mt-3`} name='existing-policy-info' id='existing-policy-info'>Existing Policy Information</h5>
                            <Row>
                                <Col md={4}><b name='existing-policy-carrier-text' id='existing-policy-carrier-text'>Carrier:</b> <span name='existing-policy-carrier-value' id='existing-policy-carrier-value'>{existingPolicyInformation.carrier}</span></Col>
                                <Col md={4}><b name='existing-policy-number-text' id='existing-policy-number-text'>Policy Number:</b> <span name='existing-policy-number-value' id='existing-policy-number-value'>{existingPolicyInformation.policyNumber}</span></Col>
                            </Row>
                            </React.Fragment>
                        }

                        {(existingPolicyInformation.objective || existingPolicyInformation.coverage) &&
                            <React.Fragment>
                                <h5 className={`${classes.primaryColor}  font-weight-bold mt-3`} name='policy-objective-info' id='policy-objective-info'>Policy Objective Information</h5>
                                <Row>
                                    <Col md={4}><b name='policy-objective-text' id='policy-objective-text'>Objectives:</b> <span name='policy-objective-value' id='policy-objective-value'>{existingPolicyInformation.objective || ' '}</span></Col>
                                    <Col md={4}><b name='policy-coverage-text' id='policy-coverage-text'>Current Coverage Needed:</b> <span name='policy-coverage-value' id='policy-coverage-value'>{existingPolicyInformation.coverage || ' '}</span></Col>
                                </Row>
                            </React.Fragment>
                        }

                        {existingPolicyInformation.otherOwner &&
                            <React.Fragment>
                                <h5 className={`${classes.primaryColor}  font-weight-bold mt-3`} name='owner-info' id='owner-info'>Owner Information</h5>
                                {existingPolicyInformation.ownerType === "person" ?
                                    <Row>
                                    <Col md={4}><b name='owner-type-text' id='owner-type-text'>Owner Type:</b> <span name='owner-type-value' id='owner-type-value'>{existingPolicyInformation.ownerType}</span></Col>
                                    <Col md={4}><b name='owner-first-name-text' id='owner-first-name-text'>First Name:</b> <span name='owner-first-name-value' id='owner-first-name-value'>{existingPolicyInformation.ownerFirstName}</span></Col>
                                    <Col md={4}><b name='owner-last-name-text' id='owner-last-name-text'>Last Name:</b> <span name='owner-last-name-value' id='owner-last-name-value'>{existingPolicyInformation.ownerLastName}</span></Col>
                                    <Col md={4}><b name='owner-email-text' id='owner-email-text'>Email:</b> <span name='owner-email-value' id='owner-email-value'>{existingPolicyInformation.ownerEmail}</span></Col>
                                    </Row>
                                    : <Row>
                                    <Col md={4}><b name='trust-owner-type-text' id='trust-owner-type-text'>Owner Type:</b> <span name='trust-owner-type-value' id='trust-owner-type-value'>{existingPolicyInformation.ownerType}</span></Col>
                                    <Col md={4}><b name='trust-name-text' id='trust-name-text'>Trust Name:</b> <span name='trust-name-value' id='trust-name-value'>{existingPolicyInformation.trustName}</span></Col>
                                    <Col md={4}><b name='trust-email-text' id='trust-email-text'>Email:</b> <span name='trust-email-value' id='trust-email-value'>{existingPolicyInformation.trusteeEmail}</span></Col>
                                    </Row>
                                }
                            </React.Fragment>
                        }
                    </Container>
                </Modal.Body>
            </Modal>
        </Container>


    )
}

Submit.propTypes = {
    formState: PropTypes.object.isRequired,
};

Submit.DefaultFormState = () => {
    return {
        policyReviewId: '',
    };
};





// WEBPACK FOOTER //
// ./src/components/PolicyReview/PermReview/steps/Submit.js